/* 
  ### Chart Default Data ### 
  Predefined component's behaviors for the Filter & Action
*/


// System Completion
import DM_DS_MOST_PUNCH           from '../Project_Demo/Dashboard/SystemCompletion/Most_Punch/index.vue'
import DM_DS_MOST_ITRS            from '../Project_Demo/Dashboard/SystemCompletion/Most_ITRs/index.vue'
import DM_DS_SLIDE_PUNCH          from '../Project_Demo/Dashboard/SystemCompletion/Slide_Punch/index.vue'

import DM_SUBSYSTEM               from '../Project_Demo/SystemCompletion/SubSystem/index.vue'
import DM_SYSTEM                  from '../Project_Demo/SystemCompletion/System/index.vue'
import DM_STATUS_SHEETS           from '../Project_Demo/SystemCompletion/Status_Sheets/index.vue'
import DM_STATUS_SHEETS_SINGLE    from '../Project_Demo/SystemCompletion/Status_Sheets_Single/index.vue'
import DM_SKYLINE_MCC             from '../Project_Demo/SystemCompletion/Skyline_MCC/index.vue'
import DM_SKYLINE_PCC             from '../Project_Demo/SystemCompletion/Skyline_PCC/index.vue'
import DM_LOGIC_CHARTS            from '../Project_Demo/SystemCompletion/LogicCharts/index.vue'
import DM_RADIAL_MC               from '../Project_Demo/SystemCompletion/Radial_MC/index.vue'
import DM_RADIAL_PC               from '../Project_Demo/SystemCompletion/Radial_PC/index.vue'
import DM_SYSTEM_BOUNDARY         from '../Project_Demo/SystemCompletion/System_Boundary/index.vue'

import DM_UNIT_PLOT_PLAN          from '../Project_Demo/SystemCompletion/Unit_Plotplan/index.vue'
import DM_UNIT_HANDOVER           from '../Project_Demo/SystemCompletion/Unit_Handover/index.vue'
import DM_UNIT_MAINPAGE           from '../Project_Demo/SystemCompletion/Unit_MainPage/index.vue'
import DM_UNIT_GANTT              from '../Project_Demo/SystemCompletion/Unit_Gantt/index.vue'
import DM_UNIT_RADIAL             from '../Project_Demo/SystemCompletion/Unit_Radial/index.vue'
import DM_UNIT_STATUS             from '../Project_Demo/SystemCompletion/Unit_Status/index.vue'
import DM_UNIT_RUNDOWN            from '../Project_Demo/SystemCompletion/Unit_Rundown/index.vue'
import DM_UNIT_SLIDE              from '../Project_Demo/SystemCompletion/Unit_Slide/index.vue'


// Modal
import DM_MW_SCH_AREA             from '../Project_Demo/ModalWindow/Schedule/Area/index.vue'
import DM_MW_SCH_ZONE             from '../Project_Demo/ModalWindow/Schedule/Zone/index.vue'
import DM_MW_SCH_EREC             from '../Project_Demo/ModalWindow/Schedule/Erection/index.vue'
import DM_MW_SCH_PE1              from '../Project_Demo/ModalWindow/Schedule/PE1/index.vue'
import DM_MW_SCH_BLOCK            from '../Project_Demo/ModalWindow/Schedule/Block/index.vue'

import DM_MW_OUT_AREA_SPOOL       from '../Project_Demo/ModalWindow/Outfitting/Area_Spool/index.vue'
import DM_MW_OUT_AREA_EQ          from '../Project_Demo/ModalWindow/Outfitting/Area_EQ/index.vue'
import DM_MW_OUT_OVERALL          from '../Project_Demo/ModalWindow/Outfitting/Overall_Disc/index.vue'

import DM_CP_Status               from '../00_System/Components/index.vue'
export default {
  
  // System Completion
  DM_DS_MOST_PUNCH,
  DM_DS_SLIDE_PUNCH,
  DM_DS_MOST_ITRS,
  DM_SKYLINE_MCC,
  DM_SKYLINE_PCC,
  DM_LOGIC_CHARTS,
  DM_SUBSYSTEM,
  DM_SYSTEM,
  DM_STATUS_SHEETS,
  DM_STATUS_SHEETS_SINGLE,
  DM_RADIAL_MC,
  DM_RADIAL_PC,
  DM_SYSTEM_BOUNDARY,
  
  DM_UNIT_PLOT_PLAN,
  DM_UNIT_HANDOVER,
  DM_UNIT_MAINPAGE,
  DM_UNIT_GANTT,
  DM_UNIT_RADIAL,
  DM_UNIT_STATUS,
  DM_UNIT_RUNDOWN,
  DM_UNIT_SLIDE,
  
  // Modal
  DM_MW_SCH_AREA,
  DM_MW_SCH_ZONE,
  DM_MW_SCH_EREC,
  DM_MW_SCH_PE1,
  DM_MW_SCH_BLOCK,
  
  DM_MW_OUT_AREA_SPOOL,
  DM_MW_OUT_AREA_EQ,
  DM_MW_OUT_OVERALL,
  DM_CP_Status,
}
